import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { TerminalUsersTable } from "./TerminalUserTable/TerminalUserTable";
import { useStore } from "../../../store";
import { Helmet } from "react-helmet-async";

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const TerminalUsers = () => {
  const [loggedPosUserList] = useStore("loggedPosUserList");
  const [user] = useStore("auth", "user");
  const [viewLoggedUsersPermission, setViewLoggedUsersPermission] = useState<
    boolean
  >(false);
  const [editLoggedUsersPermission, setEditLoggedUsersPermission] = useState<
    boolean
  >(false);

  useEffect(() => {
    const loggedUsersPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 15
    );
    if (user.is_super_admin === true) {
      setEditLoggedUsersPermission(true);
      setViewLoggedUsersPermission(true);
    } else {
      if (loggedUsersPermission) {
        if (loggedUsersPermission.is_edit === true) {
          setEditLoggedUsersPermission(true);
        }
        if (loggedUsersPermission.is_view === true) {
          setViewLoggedUsersPermission(true);
        }
      }
    }
  });

  return (
    <>
      <Helmet>
        <title>Terminal users</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        {viewLoggedUsersPermission === true ? (
          <Grid item xs={12}>
            <TerminalUsersTable
              terminalUsers={loggedPosUserList}
              editLoggedUsersPermission={editLoggedUsersPermission}
            />
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};
